import { render } from "./LottoResultsSlider.vue?vue&type=template&id=1f34a65a&scoped=true"
import script from "./LottoResultsSlider.vue?vue&type=script&lang=js"
export * from "./LottoResultsSlider.vue?vue&type=script&lang=js"

import "./LottoResultsSlider.vue?vue&type=style&index=0&id=1f34a65a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f34a65a"]])

export default __exports__